window.MaissonDesign.register(({on,cleanup}) => {
on(document.querySelector('[data-locale-switch]'), 'click', event => {
  const link = event.currentTarget;
  const url = new URL(link.href);
  url.search = location.search;
  url.hash = location.hash;
  link.href = url.href;
});

const video = document.getElementById('studio-film');
  const button = document.getElementById('studio-playback');
  const status = document.getElementById('studio-status');
  if (!video || !button) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let wantsPlayback = !reduced.matches;
  let visible = true;
  video.muted = true;
  video.defaultMuted = true;
  video.autoplay = !reduced.matches;
  video.loop = true;
  video.preload = 'auto';
  video.controls = false;
  button.hidden = false;

  function updateButton() {
    const label = video.ended ? button.dataset.replay || 'Replay film' : video.paused ? button.dataset.play || 'Play film' : button.dataset.pause || 'Pause film';
    button.textContent = `${label} ${video.paused || video.ended ? '▷' : 'Ⅱ'}`;
    button.setAttribute('aria-label', label);
  }
  async function playIfAllowed() {
    if (!wantsPlayback || !visible || document.hidden) return;
    try { await video.play(); } catch { updateButton(); }
  }
  on(button, 'click', () => {
    if (video.paused || video.ended) {
      if (video.ended) video.currentTime = 0;
      wantsPlayback = true;
      playIfAllowed();
    } else { wantsPlayback = false; video.pause(); }
  });
  ['play', 'pause', 'ended', 'loadedmetadata'].forEach(event => on(video, event, updateButton));
  on(video, 'error', () => {
    button.hidden = true;
    status.textContent = button.dataset.error || 'The film could not load. The studio photograph is shown instead.';
  });
  on(document, 'visibilitychange', () => { if (document.hidden) video.pause(); else playIfAllowed(); });
  on(reduced, 'change', () => {
    video.autoplay = !reduced.matches;
    if (reduced.matches) { wantsPlayback = false; video.pause(); }
  });
  if ('IntersectionObserver' in window) {
    const visibilityObserver = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) playIfAllowed(); else video.pause();
    }, { threshold: 0.15 }); visibilityObserver.observe(video); cleanup(() => visibilityObserver.disconnect());
  } else playIfAllowed();
  updateButton();
  playIfAllowed();

cleanup(() => video.pause());
});
